import PageHero from '../components/PageHero';
import { juridiskDetails } from '../data';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function JuridiskRaadgivning() {
  return (
    <main className="bg-white">
      <SEO 
        title="Juridisk Rådgivning | Erhvervsret, Kontrakter & Compliance – FINANJU"
        description="Sikr din virksomheds juridiske fundament med FINANJU. Vi rådgiver om erhvervsret, kontrakter, selskabsret, omstrukturering og compliance."
        path="/juridisk-raadgivning"
      />
      <PageHero
        title="Juridisk Rådgivning"
        subtitle="Sikr din virksomheds juridiske fundament med kompetent og nærværende rådgivning."
        breadcrumbs={[
          { name: 'Ydelser', href: '/ydelser' },
          { name: 'Juridisk rådgivning', href: '/juridisk-raadgivning' }
        ]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Juridisk tryghed i din daglige drift</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-6">
                I erhvervslivet er velskrevne kontrakter og overholdelse af lovgivningen afgørende for at minimere risici og sikre et stabilt samarbejde med partnere, kunder og medarbejdere.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed mb-10">
                Hos FINANJU yder vi praktisk orienteret juridisk rådgivning, der er til at forstå. Vi hjælper dig med at navigere i reglerne, så du kan drive din virksomhed med ro i maven.
              </p>
              <div className="space-y-6">
                {juridiskDetails.map((detail, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="mt-1">
                      <CheckCircle2 className="h-6 w-6 text-[#876a57]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-1">{detail.title}</h3>
                      <p className="text-slate-500">{detail.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-16 lg:mt-0 relative">
              <div className="aspect-[4/3] rounded-sm overflow-hidden bg-slate-100 shadow-2xl">
                <img
                  src="/images/minimalist-meeting-room.png"
                  alt="Minimalistisk mødelokale til juridisk rådgivning"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Dark CTA Box */}
          <div className="bg-slate-900 rounded-sm p-12 lg:p-16 text-center shadow-lg relative overflow-hidden">
             <div className="absolute inset-0 z-0">
                <img
                  src="/images/consultation.png"
                  alt="Background"
                  className="w-full h-full object-cover opacity-10 grayscale mix-blend-multiply"
                />
             </div>
             <div className="relative z-10">
                <h3 className="text-2xl font-bold text-white mb-6">Få skræddersyet en løsning</h3>
                <p className="text-slate-300 mb-10 max-w-2xl mx-auto">
                  Lad os tage en uforpligtende dialog om, hvordan vi kan sikre din virksomheds juridiske fundament.
                </p>
                <Link to="/kontakt?emne=juridisk-rådgivning" className="cta-button">
                  Kontakt FINANJU
                </Link>
             </div>
          </div>
        </div>
      </section>
    </main>
  );
}
